// extracted by mini-css-extract-plugin
export default {"root":"RichListItemContent_root__5P4qL"};